export default Object.freeze([
  { name: 'Owners Home Address', value: 'customer_address' },
  { name: 'Vet Address', value: 'vet_address' },
  { name: 'Other Home Address', value: 'postal_address' },
]);